import React from 'react';

import { Typography } from '@mui/material';

import { formatNumberToFixed2DecimalsExceptNull } from 'utils/number';

import ActionButton from './ActionButton';
import { TableColumnId } from './OtherExpenses.constants';

export const getTableConfig = ({
  setEditableData,
  deleteTableData,
  editableRowId,
  isActionDisabled,
}) => ({
  [TableColumnId.NAME]: {
    label: 'Type',
    width: '45%',
    sort: true,
    colSpan: ({ name }) => name?.colSpan,
    customStyles: ({ name }) => name?.customStyles,
    content: ({ name }) =>
      name?.content ?? (
        <Typography data-truncated className="truncate" variant="regular14">
          {name}
        </Typography>
      ),
  },
  [TableColumnId.VALUE]: {
    label: 'Monthly Amount',
    sort: true,
    width: '45%',
    content: ({ value }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {value ? `$${formatNumberToFixed2DecimalsExceptNull(Number(value))}` : ''}
      </Typography>
    ),
  },
  action: {
    label: 'Action',
    width: '10%',
    content: rowData => {
      return (
        <ActionButton
          deleteTableData={deleteTableData}
          isDisabled={isActionDisabled || (!!editableRowId && rowData.id !== editableRowId)}
          isEditDisabled={rowData.id === editableRowId}
          rowData={rowData}
          setEditableData={setEditableData}
        />
      );
    },
    align: 'center',
  },
});
